var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.05 0H3.55C1.59 0 0 1.59 0 3.55V18.37C0 20.33 1.59 21.92 3.55 21.92H12.05C14.01 21.92 15.6 20.33 15.6 18.37V3.55C15.6 1.59 14.01 0 12.05 0ZM2.3 3.55C2.3 2.86 2.86 2.3 3.55 2.3H12.05C12.74 2.3 13.3 2.86 13.3 3.55V18.37C13.3 19.06 12.74 19.62 12.05 19.62H3.55C2.86 19.62 2.3 19.06 2.3 18.37V3.55Z",
    fill: "#D1A437"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8401 18.38H6.7501C6.1101 18.38 5.6001 17.86 5.6001 17.23C5.6001 16.59 6.1101 16.08 6.7501 16.08H8.8401C9.4801 16.08 9.9901 16.6 9.9901 17.23C9.9901 17.87 9.4801 18.38 8.8401 18.38Z",
    fill: "#D1A437"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.aefa5867e2f903c50be73e5d55fcf8cf.svg";
export { ForwardRef as ReactComponent };